module.exports = "../assets/yachtfull-logo-white-bg-no-brands.891ee2ab.svg";